type SetLocaleCookie = (locale: string) => string;
export const setLocaleCookie: SetLocaleCookie = (locale) =>
  (document.cookie = `locale=${locale};path=/;max-age=315360000;domain=${
    process.env.NODE_ENV === "production"
      ? "mywarhammer.com"
      : window.location.hostname
  }`);
